<template>
	<div ref="myElement" class="container">
		<div class="main_box">
			<div class="block_1">
				<div v-if="newsList.length > 0">
					<div class="list_box">
						<div
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
							v-for="(value, index) in newsList"
							:key="index"
							class="list_el"
							@click="goInfo(value)"
						>
							<img :src="webUrl + value.image" />
							<div class="tit">{{ value.title }}</div>
							<div class="time">{{ value.fabu_time }}</div>
						</div>
					</div>
					<div
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						class="page_box"
					>
						<el-pagination
							:small="false"
							background
							layout="prev, pager, next"
							:total="total"
							:page-size="12"
							:pager-count="5"
							@current-change="pageChange"
						>
						</el-pagination>
					</div>
				</div>
				<div
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
					v-if="newsList.length == 0 && !listLoading"
				>
					<van-empty image="search" description="暂无数据~" />
				</div>
			</div>
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import { newsList } from '@/api/public';  //新闻列表
import { UPURL } from '@/util/util';
export default {
	components:{
		//
	},
	data() {
		return {
			isLoading: true,  //界面loading
			newsList: [],
			page: 1,
			total: 0,
			listLoading: true,
			webUrl: UPURL,
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
		that.isLoading = false;
		//获取新闻列表
		that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
		that.getList();
	},
	watch: {
		//
	},
	methods: {
		//分页点击
		pageChange(val) {
			let that = this;
			that.page = val;
			that.getList(true);
		},
		//获取列表
		getList(type) {
			let that = this;
			that.listLoading = true;
			newsList({
				page: that.page,
				page_size: 12,
				leixing: 2,
				language: sessionStorage.getItem('lang')
			}).then(res => {
				that.newsList = res.data.data;
				that.total = res.data.total;
				that.$toast.clear();
				that.listLoading = false;
				if(type) {
					//滚动到列表顶部
					that.$refs.myElement.scrollIntoView({ behavior: 'smooth' });
				}
			});
		},
		//点击查看详情
		goInfo(value) {
			let that = this;
			that.$router.push({ name: 'NewsInfo', params: { newInfoId: value.id + '.html' } });
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #333333;
	.block_1{
		padding: 0 16px 40px 16px;
		.list_box{
			.list_el{
				margin-bottom: 40px;
				.time{
					padding-top: 8px;
					color: #B8B8B8;
					font-size: 16px;
				}
				.tit{
					padding-top: 15px;
					font-size: 16px;
				}
				img{
					width: 100%;
				}
			}
		}
		.page_box{
			padding-top: 10px;
			text-align: center;
		}
	}
}
</style>
<style scoped>
/*分页*/
>>> .page_box .el-pager li:hover{
	color: #C8000A !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active{
	background-color: #C8000A !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active:hover{
	color: #ffffff !important;
}
</style>